(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[173],{

/***/ "3+yQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Hr; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("C/y5");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;


var Hr = function Hr(_ref) {
  var className = _ref.className;
  return __jsx("hr", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__[/* classnames */ "a"])('block border-0 border-solid border-lightGrey border-t-1 h-1 m-0 p-0', className)
  });
};

/***/ }),

/***/ "Smcz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jQ/y");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("MwrP");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("SPKZ");
/* harmony import */ var _components_utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("u/u4");
/* harmony import */ var _components_frameworks_hr_Hr__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("3+yQ");
/* harmony import */ var _components_frameworks_image_Image__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("0IQ5");
/* harmony import */ var _components_frameworks_responsive_tabs_ResponsiveTabs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("QPCF");
/* harmony import */ var _components_frameworks_site_container_SiteContainer__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("ZNfd");
/* harmony import */ var _components_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("qqKu");
/* harmony import */ var _components_frameworks_title_Title__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("MWZw");





var __jsx = react__WEBPACK_IMPORTED_MODULE_5___default.a.createElement;










var Area = function Area(props) {
  var _props$resort = props.resort,
      _props$resort$name = _props$resort.name,
      title = _props$resort$name === void 0 ? '' : _props$resort$name,
      _props$resort$destina = _props$resort.destination,
      destination = _props$resort$destina === void 0 ? {} : _props$resort$destina,
      productVideo = _props$resort.productVideo,
      _props$resort$strengt = _props$resort.strengths,
      strengths = _props$resort$strengt === void 0 ? [] : _props$resort$strengt;
  var description = destination.description;
  return __jsx(react__WEBPACK_IMPORTED_MODULE_5__["Fragment"], null, __jsx(_components_frameworks_hr_Hr__WEBPACK_IMPORTED_MODULE_8__[/* Hr */ "a"], {
    className: "my-20"
  }), __jsx("div", {
    className: "sm:flex"
  }, __jsx(_components_frameworks_title_Title__WEBPACK_IMPORTED_MODULE_13__[/* Title */ "a"], {
    className: "sm:w-1/4",
    theme: "title-brand-n1"
  }, title), __jsx("div", {
    className: "sm:w-3/4"
  }, __jsx(_components_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_12__[/* Text */ "a"], {
    text: description
  }), description ? __jsx(_components_frameworks_hr_Hr__WEBPACK_IMPORTED_MODULE_8__[/* Hr */ "a"], {
    className: "my-20"
  }) : null, __jsx("div", {
    className: "flex flex-col gap-20 sm:flex-row"
  }, __jsx("div", {
    className: "sm:basis-1/3"
  }, __jsx(_components_frameworks_image_Image__WEBPACK_IMPORTED_MODULE_9__[/* Image */ "a"], {
    imageUrl: productVideo,
    ratioKey: _components_utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_7__[/* default */ "c"].XL
  })), !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_4___default()(strengths) ? __jsx("ul", {
    "data-testid": "Destination-strengths",
    className: "text-14 sm:basis-2/3"
  }, strengths.map(function (strength) {
    return __jsx("li", {
      key: strength,
      className: "list-disc"
    }, strength);
  })) : null))));
};

var TabContent = function TabContent(_ref) {
  var content = _ref.content;

  if (!content) {
    return null;
  }

  return __jsx(_components_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_12__[/* Text */ "a"], {
    text: content
  });
};

function hasResponsiveTabs(practicalInformation) {
  return !!(practicalInformation.healthFormalities || practicalInformation.passportAndVisas);
}

var ProductDestinationsLine = function ProductDestinationsLine(props) {
  var healthFormalities = props.healthFormalities,
      passportAndVisas = props.passportAndVisas,
      resort = props.resort;
  var _resort$strengths = resort.strengths,
      strengths = _resort$strengths === void 0 ? [] : _resort$strengths,
      description = resort.description,
      practicalInformation = resort.practicalInformation;
  var shouldRenderArea = strengths.length > 0 || !!resort.productVideo;
  var tabsItems = Object(react__WEBPACK_IMPORTED_MODULE_5__["useMemo"])(function () {
    return [{
      header: {
        iconName: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_6__[/* ICONS */ "a"].HEALTH,
        title: healthFormalities
      },
      content: [__jsx(TabContent, {
        key: "health",
        content: practicalInformation.healthFormalities
      })]
    }, {
      header: {
        iconName: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_6__[/* ICONS */ "a"].PASSPORT,
        title: passportAndVisas
      },
      content: [__jsx(TabContent, {
        key: "passport",
        content: practicalInformation.passportAndVisas
      })]
    }];
  }, [passportAndVisas, healthFormalities, practicalInformation.passportAndVisas, practicalInformation.healthFormalities]);
  return __jsx(_components_frameworks_site_container_SiteContainer__WEBPACK_IMPORTED_MODULE_11__[/* SiteContainer */ "a"], {
    className: "Line",
    "data-testid": "ProductInformationDestination"
  }, __jsx("div", {
    className: "flex flex-col gap-20 sm:flex-row"
  }, __jsx(_components_frameworks_title_Title__WEBPACK_IMPORTED_MODULE_13__[/* Title */ "a"], {
    className: "sm:basis-1/4",
    theme: "title-brand-n1"
  }, resort.destination.country), __jsx("div", {
    className: "sm:basis-3/4"
  }, __jsx(_components_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_12__[/* Text */ "a"], {
    text: description
  }), hasResponsiveTabs(practicalInformation) && __jsx(_components_frameworks_responsive_tabs_ResponsiveTabs__WEBPACK_IMPORTED_MODULE_10__[/* ResponsiveTabs */ "a"], {
    areAllCollapsable: true,
    className: "mt-20",
    isContainerWide: true,
    items: tabsItems
  }))), shouldRenderArea ? __jsx(Area, props) : null);
};

/* harmony default export */ __webpack_exports__["default"] = (ProductDestinationsLine);

/***/ })

}]);